import { useClassNames } from "@/utils/classNames";
import { formatTime } from "@/utils/FormatTime";

import styles from "./Duration.module.scss";
import { DurationProps } from "./types";

/**
 * Duration component displays the total video duration
 * Shown beside the progress bar on the right side
 *
 * @param duration - Total duration in seconds
 * @param className - Additional CSS class for styling
 * @returns The Duration component
 */
const Duration = ({ duration, className }: DurationProps) => {
  const cn = useClassNames(styles, styles["duration"], className);

  return <div className={cn}>{formatTime(duration)}</div>;
};

export { Duration };
